import React from "react";
import "./downloadApp.css";
import logo from "../../../Assets/Vector.svg";
import apple from "../assets/apple-btn.png";
import playstore from "../../../Assets/playstore.svg";
import ovestdesktop from "../../../Assets/ovestdesktop.svg";
import { TextLink } from "../../../Syles/styles";
import DownloadAPK from "./DownloadAPK";
import { Link } from "react-router-dom";

const DownloadApp = () => {
  return (
    <div className="download-app-section">
      <div className="download-main">
        <div className="ovest-logo-container">
          <Link to="/">
            <img src={logo} alt="" />
            <p>OVest</p>
          </Link>
        </div>
        <div className="desktop-icon-container">
          <img src={ovestdesktop} alt="" />
          <p className="mt-5 ">
            For a better experience, we advise you to visit
            <a
              href="http://myovest.com/app"
              target="_blank"
              style={{
                textDecoration: "none",
                color: "#00a8ff",
              }}
            >
              &nbsp; here &nbsp;
            </a>
            to download and Install OVest APP Android APK
          </p>

          <p className="mt-5 ">
            Are you an Existing OVestor? Visit
            <a
              href="http://old.myovest.com/login"
              target="_blank"
              style={{
                textDecoration: "none",
                color: "#00a8ff",
              }}
            >
              &nbsp;here&nbsp;
            </a>
            to Access Your Previous Portal
          </p>
          <DownloadAPK />
          {/* <p className="mt-5 ">
            Download and Install Andriod APK
            <a href="http://myovest.com/app" target="_blank">
              Here
            </a>
            Here
          </p> */}
        </div>

        {/* <div className="app-button">
          <img src={apple} alt="" className="" />
          <img src={playstore} alt="" className="playstore" />

          <a
            href="
          http://myovest.com/app/download
          "
            target="_blank"
          >
            <button>
              <i class="fas fa-download"></i>
              Download APK
            </button>
          </a>
        </div> */}
      </div>
    </div>
  );
};

export default DownloadApp;
